import React from "react";
import { useState } from "react";
import "./experience.css";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";

function Experience() {
  const data = [
    // { start: "985", end: "1000", content: "Pieces Of Content Created" },
    // { start: "0", end: "2", content: "Media Planner" },
  ];

  const [counterOn, setCounterOn] = useState(false);
  const [played, setPlayed] = useState(false);
  return (
    <ScrollTrigger
      onEnter={() => {
        played ? setCounterOn(false) : setPlayed(true);

        setCounterOn(true);
      }}
      // onEnter={()=> setCounterOn(true)}
      // onExit={()=>setCounterOn(false)}
    >
      <div className="experience-container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-title-ex">
            <h1
              data-aos="fade-right"
              data-aos-delay="200"
              data-aos-duration="1000"
            >
              What We
            </h1>
            <h1
              className="ex-middle-title"
              data-aos="fade-right"
              data-aos-delay="150"
              data-aos-duration="1900"
            >
              Achieved
            </h1>

            <h1
              data-aos="fade-right"
              data-aos-delay="150"
              data-aos-duration="1900"
            >
              For Clients
            </h1>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 ">
            <div className="row row-col-ex">
              <div className="col-6  ex-col">
                <h1 className="">
                  {counterOn && (
                    <CountUp start={985} end={1000} duration={4} delay={0} />
                  )}
                  +
                </h1>
                <p className="">Pieces Of Content Created</p>
              </div>
              <div className="col-6  ex-col">
                <h1 className="">
                  {counterOn && (
                    <CountUp start={0} end={2} duration={4} delay={0} />
                  )}
                  .
                  {counterOn && (
                    <CountUp start={0} end={5} duration={4} delay={0} />
                  )}
                  M+
                </h1>

                <p className="">Total Organic Views</p>
              </div>
            </div>
            {/* <div className="row row-col-ex">
              {data.map((item, index) => (
                <div className="col-6  ex-col" key={index}>
                  <h1>
                    {counterOn && (
                      <CountUp
                        start={item.start}
                        end={item.end}
                        duration={4}
                        delay={0}
                      />
                    )}
                    +
                  </h1>
                  <p className="">{item.content}</p>
                </div>
              ))}
            </div> */}

            <div className="row row-col-ex align-items-center d-flex">
              <div className="col-6  ex-col ex-3">
                <h1 className="">
                  {counterOn && (
                    <CountUp start={0} end={2} duration={4} delay={0} />
                  )}
                  .
                  {counterOn && (
                    <CountUp start={70} end={78} duration={4} delay={0} />
                  )}
                  %
                </h1>
                <p className="">Avg. Engagement Rate</p>
              </div>
              <div className="col-6  ex-col">
                <h1 className="">
                  {counterOn && (
                    <CountUp start={0} end={5} duration={4} delay={0} />
                  )}
                  +
                </h1>
                <p className="">Skilled Team Members</p>
              </div>
              {/* <div className="col-6  ex-col">
                <img
                  src="/images/cannes-young-lions 1.png"
                  alt="ex-img-lion"
                ></img>
                <p className="">2016</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </ScrollTrigger>
  );
}

export default Experience;
